"use client";

import React from "react";
import { Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToTransformYourYard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="163112" id="הזמנת-מטפל-מיידית" className="relative overflow-hidden bg-background py-24 sm:py-32 shadow-2xl">
      {}
      <div className="pointer-events-none absolute top-0 left-0 -translate-x-1/3 -translate-y-1/4 opacity-10 dark:opacity-5">
        <Leaf className="size-64 text-chart-3" strokeWidth={0.5} />
      </div>
      <div className="pointer-events-none absolute right-0 bottom-0 translate-x-1/3 translate-y-1/4 opacity-10 dark:opacity-5">
        <Leaf className="size-80 text-primary" strokeWidth={0.5} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl font-bold tracking-tight text-primary sm:text-5xl lg:text-6xl mb-6">
            צריך מטפל סיעודי עכשיו?
          </h2>
          
          <p className="text-lg text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed font-default">
            הצוות המקצועי שלנו עומד לרשותכם 24/7 למתן מענה של <Link to="/CaregiverServicePagesPage" className="text-primary hover:underline font-medium">מטפל סיעודי</Link> מהיר, אמין ומקצועי בכל רחבי הארץ. אנו מספקים שירותי <Link to="/CaregiverServicePagesPage" className="text-primary hover:underline font-medium">מטפל סיעודי בבית</Link> וכן <Link to="/CaregiverServicePagesPage2" className="text-primary hover:underline font-medium">השגחה בבית חולים</Link> ברמה הגבוהה ביותר. בין אם אתם מחפשים <Link to="/NursingCaregiverInTelAvivWithinFiveHoursPage" className="text-primary hover:underline font-medium">מטפל סיעודי בתל אביב</Link>, <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="text-primary hover:underline font-medium">מטפל סיעודי בירושלים</Link> או <Link to="/NursingCareProviderInHaifaWithinHoursPage" className="text-primary hover:underline font-medium">מטפל סיעודי בחיפה</Link>, אנחנו כאן עבורכם. קראו במדריך שלנו <Link to="/ProfessionalBlogPage" className="text-primary hover:underline font-medium">איך לבחור מטפל סיעודי</Link> כדי להעניק ליקיריכם שקט נפשי וטיפול מסור.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] sm:w-auto h-14 px-8 text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 rounded-lg font-default">
              <Link to="tel:0500000000">התקשר עכשיו</Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base border-chart-3/30 text-chart-3 hover:bg-chart-3/5 dark:border-chart-3/50 dark:hover:bg-chart-3/10 rounded-lg animate-pulse font-default">
              <Link to="https://wa.me/972500000000">וואטסאפ מיידי</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}